import apiClient from '@/api/apiClient.js';
import { getInstProfesId, getPatPatientsId } from '../../utils/storeHelpers';

export default {
  namespaced: true,
  state: {
    usersCodeVerifGen: "",
    usersCodeVerif: "",
    usersPin: false,
  },

  getters: {
    usersCodeVerifGen(state) {
      return state.usersCodeVerifGen;
    },
    usersCodeVerif(state) {
      return state.usersCodeVerif;
    },
    usersPin(state) {
      return state.usersPin;
    },
  },

  mutations: {
    insertUsersCodeVerifGen(state, usersCodeVerifGen) {
      state.usersCodeVerifGen = usersCodeVerifGen;
    },
    insertUsersCodeVerif(state, usersCodeVerif) {
      state.usersCodeVerif = usersCodeVerif;
    },
    insertUsersPin(state, usersPin) {
      state.usersPin = usersPin;
    },
    sendSuccess(state) {
      state.status = 'success';
    },
    sendError(state) {
      state.status = 'error';
    },
  },

  actions: {
    async getUsersCodeVerif({ commit }, { model }) {
      try {
        const type = model.type;

        let id;
        if (type === 'Pro') {
          id = getInstProfesId();
        } else if (type === 'Pat') {
          id = getPatPatientsId();
        }

        if (id === undefined || id === null || id === '') {
          console.warn('ID inválido:', id);
          return;
        }

        const res = await apiClient.usersCodeVerif(id, model);
        const usersCodeVerif = res.data.data.codeVerifMatch;

        commit('insertUsersCodeVerif', usersCodeVerif);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },

    async getUsersCodeVerifGen({ commit }, payload) {
      try {
        let model = payload;
        let type = payload.type;
        let id;
        if (type === 'Pro') {
          id = getInstProfesId();
        } else if (type === 'Pat') {
          id = getPatPatientsId();
        }

        if (id === undefined || id === null || id === '') {
          console.warn('ID inválido:', id);
          return;
        }

        const res = await apiClient.usersCodeVerifGen(id, model);
        const usersCodeVerifGen = res.data.data.codeVerifGen;
        commit('insertUsersCodeVerifGen', usersCodeVerifGen);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },

    async getUsersPin({ commit }, { model }) {
      try {
        const type = model.type;
        let id;
        if (type === 'Pro') {
          id = getInstProfesId();
        } else if (type === 'Pat') {
          id = getPatPatientsId();
        }

        const res = await apiClient.usersPin(id, model);
        const usersPin = res.data.data.pinMatch;

        commit('insertUsersPin', usersPin);
      } catch (error) {
        console.error('[App Error]:', error.message || 'Error desconocido');
        throw error;
      }
    },
  },
};
